/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import styled from "styled-components";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import ResisterMain from "./RegisterMain";
import Swal from "sweetalert2";
import axios from "axios";
import pr from "../lib/pr";
import { useHistory } from "react-router-dom";
import { loginState, configState } from "../lib/State";
import get_cid from "../lib/get_cid";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Login(props) {
  const { onCloseLogin, onOpenFindPass } = props;
  const [openRes, setOpenRes] = useState(false);
  const history = useHistory();

  const clickOpenRes = () => {
    setOpenRes(true);
  };

  const clickCloseRes = () => {
    setOpenRes(false);
  };

  const onOpenFindPassClick = () => {
    onCloseLogin();
    setTimeout(() => {
      onOpenFindPass();
    }, 1000 / 3);
  }

  // ID/PASS
  const [data, setData] = useState({ user_id: "", user_pass: "" });
  const onChangeData = (e) => {
    setData((state) => ({ ...state, [e.target.id]: e.target.value }));
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    const { user_id, user_pass } = data;
    axios
      .post(configState.api + "/gympass/login", { ...data, cid: get_cid() })
      .then((result) => {
        console.log(result.data.success);
        if (result.data.success === 1) {
          localStorage.setItem("token", result.data.token);
          onCloseLogin();
          window.location.href = "/home";
        }
        if (result.data.success === 0) {
          Swal.fire("인증오류",result.data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Grid
      container
      height="100vh"
      direction="column"
      css={css`
        .swal2-container {
          z-index: 20000 !important;
        }
      `}
      // overflow='scroll'
    >
      <Grid
        container
        flex="1"
        height='100vh'
        direction="column"
        justifyContent="space-between"
      >
        <Grid
          className="logo"
          style={{
            // marginLeft: '10px',
            marginTop: '30px'
          }}
        >
          <img
            className="logoimg"
            src="/img/docircuit_logo.png"
            style={{
              width: "40%",
              marginLeft: '15px',
              marginBottom: '10px'
            }}
          />
          <Box
            style={{
              margin: "0 0 10px 20px",
              fontWeight: "bold",
              fontSize: '22px'
            }}
          >
            안녕하세요.
            <br></br>
            두써킷입니다.
          </Box>
          <Box
            sx={{
              margin: '0 0 10px 20px',

            }}>
            회원 서비스 이용을 위해 로그인 해주세요.
          </Box>
          <Box
            onSubmit={onFormSubmit}
            component="form"
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
            <Box
            
            // width="100%"
            justifyContent="center"
            css={css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          `}
            
          >
            <TextField
              id="user_id"
              variant='standard'
              onChange={onChangeData}
              size="small"
              label="전화번호"
              style={{
                width: "90%",
                marginBottom: "10px",
                marginTop: '70px'
              }}
              autoComplete="off"
            ></TextField>
            <TextField
              type="password"
              id="user_pass"
              variant='standard'
              onChange={onChangeData}
              size="small"
              label="패스워드"
              style={{
                width: "90%",
                marginBottom: "10px",
              }}
              autoComplete="off"
            ></TextField>
            <Box
              style={{
                marginBottom: "10px",
              }}
            ></Box>

            <Box
              css={css`
              margin-top: 10px;
            `}
            >
              <Link onClick={onOpenFindPassClick}>비밀번호 찾기</Link>
            </Box>
            
          </Box>
          <Box
              sx={{
                textAlign: 'center'
              }}>
              <Button
                type="submit"
                variant="contained"
                style={{
                  width: "100%",
                  background: "#0092a2",
                  position: 'fixed',
                  bottom: 20,
                  left: 0,
                  borderRadius: 0
                  // marginTop: '70px',
                }}
              >
                로그인
              </Button>
            </Box>
          </Box>
          
        </Grid>



      </Grid>
    </Grid>
  );
}

export default Login;
